<template>
  <div class="search-input" :class="{ 'show': showPanel }">
    <div class="search">
      <div class="search-box">
        <img src="@static/images/search.png" class="search-icon" />
        <van-field
          class="search-input"
          clearable
          type="text"
          placeholder="请搜索产品名称"
          v-model="searchParams.productName"
          @input="
            searching = false;
            $refs.list.listCount = 0;
          "
          @click.stop="openPanel"
        />
      </div>
      <span class="cancel-btn" @click="back" v-if="showPanel && !searchParams.productName">取消</span>
      <span class="search-btn" @click="search" v-if="showPanel && searchParams.productName">搜索</span>
    </div>
    <div v-show="showPanel && (!searchParams.productName || !searching)" class="history-wrap">
      <div class="title"><span>历史记录</span><img v-if="historyList.length" @click="clearHistory" src="@static/images/icon_del.png" class="icon-del" /></div>
      <div class="content">
        <span class="box" v-for="(item, index) in historyList" :key="index" @click="chooseHis(item)">{{ item }}</span>
      </div>
    </div>
    <div class="list-panel" v-show="searchParams.productName && searching">
      <div class="list-info" v-if="$refs.list">
        共搜索到<span>{{ $refs.list.listCount }}</span
        >条相关记录
      </div>
    </div>
    <productList
      v-show="searchParams.productName && searching"
      class="list"
      :params="searchParams"
      ref="list"
      @setListParams="setListParams"
      @listCallback="listCallback"
      :showServiceFee="showServiceFee"
    ></productList>
  </div>
</template>

<script>
import productList from "./list"
export default {
  props: {
    isOrder: null,
    showServiceFee: null,
    queryGroupInsurance: null,
  },
  components: { productList },
  data() {
    return {
      timer: null,
      showPanel: false,
      name: "",
      historyList: [],
      searching: false,
      searchParams: {
        productName: ''
      }
    };
  },
  watch: {
    $route: {
      handler(val, oldval) {
        console.log(this.name);
        if (this.$route.query.showPanel == 1) {
          this.showPanel = true;
          if (localStorage.getItem('appSearchProductNameList')) {
            this.historyList = JSON.parse(localStorage.getItem('appSearchProductNameList'))
          } else {
            this.historyList = []
          }

        } else {
          this.showPanel = false;
          this.searchParams.productName = "";
          sessionStorage.removeItem("appSearchProductName");
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  mounted() {
    if (this.queryGroupInsurance == 1) {
      this.searchParams.queryGroupInsurance = 1;
    }
    if (sessionStorage.appSearchProductName) {
      this.searchParams.productName = sessionStorage.appSearchProductName;
      // this.searchParams.productName = this.name
      this.$nextTick(() => {
        this.$refs.list.init("/api/productBase/read/list");
      });
    } else {
      this.listLoading = false;
      this.finished = true;
      this.finishedText = "";
    }
  },
  methods: {
    clearHistory() {
      this.$notice.inquiry('是否清空历史记录?', ['确认', '取消'], () => {
        this.historyList = []
        localStorage.setItem('appSearchProductNameList', [])
      })
    },
    //设置参数
    setListParams(params) {
      //   console.log("setListParams")
      //   params.productName = this.name;
    },
    listCallback(res) {
      this.listLoading = false;
      this.finished = true;
      this.finishedText = "";
    },
    back() {
      this.searchParams.productName = ''
      history.go(-1);
    },
    openPanel() {
      if (this.$route.query.showPanel == 1) {
        return;
      }
      this.$router.push({
        query: { showPanel: 1 }
      })
    },
    chooseHis(item) {
      this.searchParams.productName = item;
      this.search({ target: { value: item } })
    },
    search() {
      if (!this.showPanel) {
        this.openPanel();
        return
      }
      let name = this.searchParams.productName;
      sessionStorage.appSearchProductName = name;
      clearTimeout(this.timer);
      this.timer = setTimeout(_ => {
        if (name) {
          if (this.historyList.find(i => i == name)) {
            //第一位
            let idx = this.historyList.findIndex(i => i == name)
            this.historyList.splice(idx, 1)
            this.historyList.unshift(name)
          } else {
            if (this.historyList.length >= 20) {
              this.historyList.pop()
            }
            this.historyList.unshift(name)
          }
          localStorage.setItem('appSearchProductNameList', JSON.stringify(this.historyList))
        }
      }, 600);
      if (name) {
        this.searching = true;
        this.$refs.list.searchAjax("/api/productBase/read/list");
      } else {
        this.$refs.list.listCount = 0;
        this.searching = false;
        this.$refs.list.list = [];
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import './searchInput.scss';
</style>
